import { Pipe, PipeTransform } from '@angular/core';
import { LocationsService } from '../services/locations';

@Pipe({
    name: 'fpCurrency'
})
export class FpCurrencyPipe implements PipeTransform{

  constructor(public locationsService:LocationsService){
  }

    transform(costInput: number|string){
      const cost = (+costInput).toFixed(this.locationsService.translate('decimalPlaces'));
      const costArray = cost.split('.');
      const costInt = costArray[0];
      const costDecimal = costArray[1] || '';
      let costIntWithCommas = '';
      let l = costInt.length;
      for(let i = 0;i<costInt.length-1;i++){
        var c = l - i -1;
        costIntWithCommas = costInt[c]+ costIntWithCommas;
        if(i%3===2) {
          costIntWithCommas = this.locationsService.translate('thousandsComma') + costIntWithCommas;
        }
      }
      costIntWithCommas = costInt[0]+ costIntWithCommas;
      return `${this.locationsService.translate('currencyPrefix')}${costIntWithCommas}${costDecimal ? this.locationsService.translate('currencyDecimal'):''}${costDecimal}${this.locationsService.translate('currencySuffix')}`;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/fp-currency.ts